export default function ReportEmptyChart() {
    return (
        <section className="report-empty-chart">
            No data to display
        </section>
    );
}
